import {getServerConfig} from '@@client/config'
import {getFeaturedPartPageContent} from '@@client/content/api'
import {FeaturedPartPage} from '@@client/parts/FeaturedPartPage'

export default function Page({content}) {
    if(!content) return null

    return (
        <FeaturedPartPage content={content} />
    )
}

export async function getServerSideProps(ctx) {
    const config = getServerConfig()

    const result = await getFeaturedPartPageContent(config.content.apiUrl, 'transmissions')

    return {
        props: {
            content: result.success ? result.entity : null,
        },
    }
}
